<template>
  <div class="" v-if='notEmptyGroup'>
    <!-- <button class='btn' @click='loadMore()' v-if='group.HasMoreMessages'>Load More</button> -->
    <b-nav tabs class="sticky-top bg-white top-115 pt-1">
      <b-nav-item v-bind:active="messengerTabIndex == NavTabs.Messages" v-on:click="switchTab(NavTabs.Messages)" title='Messages'>
        <img src="static/assets/img/icon-messages.png" style="margin-bottom:4px;padding-top:4px;" />
      </b-nav-item>
      <b-nav-item v-bind:active="messengerTabIndex == NavTabs.Members" v-on:click="switchTab(NavTabs.Members)" title='Members'>
        <img src="static/assets/img/MainNavIcons/icon-groups-blue.svg" height="30px" width="30px" />
      </b-nav-item>
      <!-- <b-nav-item v-bind:active="messengerTabIndex == NavTabs.Attachments" v-on:click="switchTab(NavTabs.Attachments)" title='Attachments'>
            <i class="fa fa-thumb-tack"></i>
          </b-nav-item>
          <b-nav-item v-bind:active="messengerTabIndex == NavTabs.Pinned" v-on:click="switchTab(NavTabs.Pinned)" title='Pinned'>
            <img src="static/assets/img/icon-messages.png" />
          </b-nav-item> -->
    </b-nav>
    <div v-if='loadingMessageList' class="mx-auto p-1" style="width:200px;">
      <p>
        <i class='fa  fa-spinner fa-spin'></i> Loading Messages</p>
    </div>
    <div class="max-height-container" v-if="messengerTabIndex == NavTabs.Messages" v-show='!loadingMessageList'>
      <div id="messages-container" class="scroll-y bb-1">
        <infinite-loading @infinite='infiniteHandler' direction='top' :distance='100' ref='infiniteLoading'>
          <div slot='no-more'>
            This is the beginning of the thread.
          </div>
        </infinite-loading>
        <message-list :group='passedGroup' v-if='passedGroup && passedGroup.hasOwnProperty("Users")' />
      </div>
      <div id="composer-container" v-if='isGroupMember'>
        <composer :user='user' />
      </div>
      <div id="join-container" class="py-3  text-center" v-if='!isGroupMember && notEmptyGroup'>
        <h4 class="text-steel">Please Join to Respond</h4>
        <button class='btn' @click='joinChannel()'>Join Group</button>
      </div>
    </div>
    <div v-if="messengerTabIndex == NavTabs.Members">
      <users-list v-if='passedGroup.Users' :group='passedGroup' :user='user' :is-member='isGroupMember'>
      </users-list>
    </div>
    <div v-if="messengerTabIndex == NavTabs.Attachments">C</div>
    <div v-if="messengerTabIndex == NavTabs.Pinned">D</div>
  </div>
</template>

<script>
  import Composer from './Composer'
  import MessageList from './MessageList/MessageList'
  import UsersList from './UsersList/UsersList'
  import InfiniteLoading from 'vue-infinite-loading'
  import moment from 'moment';
  import {
    aaPubnub
  } from '@/lib/pubnub/index'
  import {
    MessengerAPIClient
  } from '@/lib/data_access/messenger'

  import {
    convertIdToPubNubKind,
    convertToMotoMessage,
    isEmpty
  } from '@/lib/utilities'
  import {
    EpochTicks,
    GroupMessagingType,
    ChannelType,
    WorkflowInstanceStatus,
    NotificationType
  } from '../../lib/utilities/enums';
  export default {
    name: 'messenger',
    components: {
      Composer,
      MessageList,
      InfiniteLoading,
      UsersList
    },
    props: [
      'passedGroup',
      'user'
    ],
    data() {
      return {
        pnInstance: {},
        height: 0,
        messengerTabIndex: 0,
        NavTabs: {
          Messages: 0,
          Members: 1,
          Attachments: 2,
          Pinned: 3
        },
        previewObj: {
          Files: [],
          GroupId: '',
          Total: 0
        },
        prevIndex: 0,
        loadingMessageList: true
      }
    },
    watch: {
      height: function (newVal, oldVal) {
        let vm = this;
        var diff = newVal - oldVal;
        vm.$refs.infiniteLoading.scrollTop = diff;
      },
      'passedGroup.GroupId': {
        handler: function (newVal, oldVal) {
          let vm = this;
          vm.messengerTabIndex = 0
          if (newVal && newVal != oldVal) {
            if(vm.passedGroup && vm.passedGroup.Messages && vm.passedGroup.Messages[vm.passedGroup.Messages.length - 1] && vm.passedGroup.Messages[vm.passedGroup.Messages.length - 1].MessageId){
              MessengerAPIClient.markGroupAsRead(newVal, vm.passedGroup.Messages[vm.passedGroup.Messages.length - 1].MessageId)
              .then(function () {})
            }            
            vm.loadingMessageList = true;
            MessengerAPIClient.getGroupUsers(newVal).then(function (users) {
              let grp = vm.passedGroup
              grp.Users = users
              vm.$emit('groupupdated', grp)
              vm.loadingMessageList = false;
            })
          }
        },
        deep: true
      }
    },
    created() {
      let vm = this;
      vm.height = vm.$refs.infiniteLoading.scrollParent.scrollheight;
      vm.$refs.infiniteLoading.scrollParent.scrollTop = vm.$refs.infiniteLoading.scrollParent.offsetHeight;
    },
    computed: {
      isGroupMember: function () {
        let vm = this;
        if (vm.passedGroup && vm.passedGroup.UserIds) {
          if (vm.passedGroup.UserIds.indexOf(vm.user.Id) > -1) return true
        }
        return false
      },
      group: function () {
        let vm = this;

        if (vm.passedGroup) return vm.passedGroup;
      },
      notEmptyGroup: function () {
        let vm = this;

        return !isEmpty(vm.passedGroup)
      }

    },
    methods: {
      joinChannel: function () {
        let vm = this;

        MessengerAPIClient.joinGroup(vm.group).then(function (grpResp) {
          console.log(grpResp)
        })

      },
      switchTab: function (tabIndex) {
        this.messengerTabIndex = tabIndex;
      },
      loadMore: function () {
        let vm = this;
        console.log(vm.group.AllMessages.count, 'all messages')
        handleGetGroupHistory(vm.group).then(function () {

        })
      },
      infiniteHandler($state) {
        let vm = this;
        let loader = vm.$refs.infiniteLoading;
        vm.height = loader.scrollHeight;
        if (vm.group.HasMoreMessages & vm.isGroupMember) {
          handleGetGroupHistory(vm.group).then(function () {
            loader.scrollParent.scrollTop = loader.scrollParent.offsetHeight;
            console.log('group i am sending', vm.group)
            vm.$emit('gotgrouphistory', vm.group)
            $state.loaded();
          })
        } else {
          $state.complete();
        }

      }
    }
  }

  function addMessageToGroup(motoMSG, group) {
    try {
      if (!motoMSG || !motoMSG.MessageId || !motoMSG.Messages || motoMSG.Messages.length === 0)
        return;

      if (!group.Messages || group.Messages.length == 0)
        group.Messages = [];

      console.log('motomsg', motoMSG.MessageId)
      console.log(group.AllMessages, 'check it')
      var existingMSG = group.AllMessages.find(function (message) {
        return message.MessageId === motoMSG.MessageId;
      });



      //Update the message in all messages
      if (existingMSG) {
        //If two messages with the same id exist, display the one with the latest timestamp
        if (existingMSG.Timetoken <= motoMSG.Timetoken) {
          var index = group.AllMessages.indexOf(existingMSG);
          group.AllMessages.splice(index, 1, motoMSG);
        } else if (existingMSG.NoPubnubTimestamp)
          existingMSG.AttachmentFile = motoMSG.AttachmentFile;
      } else
        group.AllMessages.push(motoMSG);

      //Update the message in displayed messages
      if (existingMSG) {
        //If two messages with the same id exist, display the one with the latest timestamp
        if (existingMSG.Timetoken <= motoMSG.Timetoken) {
          var msgIndex = group.Messages.findIndex(msg => msg.MessageId == motoMSG.MessageId);
          if (msgIndex >= 0) {
            if (motoMSG.IsDeleted)
              group.Messages.splice(msgIndex, 1);
            else
              group.Messages.splice(msgIndex, 1, motoMSG);
          } else if (!motoMSG.IsDeleted)
            group.Messages.push(motoMSG);
        }
      } else if (!motoMSG.IsDeleted)
        group.Messages.push(motoMSG);
    } catch (err) {
      console.log(err);
    }
  }

  function updateUser(foundUser, val) {
    if (val && val.Id) {
      var userObj = foundUser
      if (userObj && userObj.Id) {
        for (var prop in val) {
          try {
            userObj[prop] = val[prop];
          } catch (err) {
            console.log('Error copying property');
          }
        }
      }
    }
    return userObj;


  }


  function handleGetGroupHistory(group) {
    console.log('GROUP I AM SENDING IN', group)
    return new Promise((resolve, reject) => {
      group.PubnubId = convertIdToPubNubKind(group.GroupId)
      aaPubnub.getInstance().pubnub.history({
        channel: group.PubnubId,
        count: 20,
        includeTimetoken: true,
        start: group.StartTimetoken
      }, (status, response) => {
        gotGroupHistory({
          group: group,
          response: response,
          status: status
        })
        console.log(status, response);
        resolve();
      }, (status) => {
        //Error Logging
        if (status.error) {
          reject(status.error)
          console.error(status.error)
        }
      })
    })
  }

  async function gotGroupHistory(data) {
    var group = data.group;
    var response = data.response;
    var status = data.status;

    console.log('go group history group', group)

    if (!group)
      return;

    if (response && response.messages) {

      if (response.messages.length > 0)
        for (var message of response.messages) {
          var motoMSG = await convertToMotoMessage(message);
          if (motoMSG)
            await addMessageToGroup(motoMSG, group);
        };

      group.EndTimetoken = group.StartTimetoken;
      group.StartTimetoken = response.startTimeToken;

      group.HasMoreMessages = response.messages.length == 20;
      sortGroupMessages(group)

      //If we don't get at least the specified amount (messageCount) of messages per iteration, fetch more
      if (group.Messages.length < group.Iteration * 20)
        handleGetGroupHistory(group);
    } else if (status.statusCode != 200) {
      console.debug(JSON.stringify(status));
      if (status.category === "PNAccessDeniedCategory" && status.operation === "PNHistoryOperation" && status.statusCode ===
        403) {
        //Pubnub denied access for this request
        console.log('Pubnub denied request to fetch messages');
        //PANDO-454: If there is any error while fetching messages from PubNub, disable the ability to fetch them and hide the LOAD MORE button
        group.HasMoreMessages = false;
      }
      group.ErrorFetchingMessages = true;
      group.Iteration -= 1;
    }
  }

  function sortGroupMessages(group) {
    let sort = group.Messages.sort(function (message1, message2) {
      return message1.CreatedTimetoken > message2.CreatedTimetoken ? 1 : -1;
    });

    group.Messages = sort;

    return group
  }

  function isImage(file) {
    return (file['type'].split('/')[0] == 'image'); //returns true or false
  }

</script>

<style lang="scss" scoped>
  .nav.nav-tabs .nav-link {
    color: $blue-lt;
    font-weight: 400; // font-size: 16px;
    // padding-bottom: 4px;
    transition: none;
  }

  .nav-tabs {
    border-bottom: 1px solid $gray-lt;
  }

  .nav-tabs .nav-link {
    border: none; // padding:.5em 0;
  }

  .nav-tabs .nav-link.active {
    border-bottom: 5px solid $blue-lt;
    color: $charcoal;
  }

  .max-height-container {
    height: calc(100vh - 292px - 60px);
    position: relative;
    width: auto;
    padding-bottom: 100px;

    #messages-container {
      height: 100%;
    }
    #join-container {
      position: absolute; // top:10px;
      left: 0;
      right: 0;
      bottom: 10px;
      background: $gray-lt;
    }
    #composer-container {
      width: 100%;
      padding: 8px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  .Mobile {
    .max-height-container {
      height: calc(100vh - 182px);
    }
  }

  .Dealsheet {
    .max-height-container {
      height: calc(100vh - 175px);
    }
  }

  @media (min-height:800px) {
    .max-height-container {
      height: calc(100vh - 349px);
    }
    .Mobile {
      .max-height-container {
        height: calc(100vh - 290px);
      }
    }
  }

  .top-115 {
    top: 115px;
  }

  @media (max-width:800px) {
    .top-115 {
      top: 90px;
    }
  }


  .avatar-container {
    min-height: 50px;
    width: 50px;
    padding: 10px;
    border-radius: 50%;
    overflow: hidden;
    img {
      height: 45px;
      width: 45px;
    }
  }

  .sender-name {
    max-width: 217px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .last-message {
    max-height: 36px;
    overflow: hidden;
    font-size: 0.8rem;
    line-height: 1.4em;
  }

  .timestamp {
    min-width: 60px;
  }

  .badge {
    background: red;
    border-radius: 50%;
    padding: 3px 5px;
    color: white;
    font-size: 0.8em;
  }

</style>



// WEBPACK FOOTER //
// src/components/Messenger/Messenger.vue